export default theme => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
});
